module.exports = __webpack_public_path__ + "assets/img/a218a7d4603f91919128cdc76d11d214.svg";